import { Fragment } from 'react';

import Tag from '@components/tag';
import { TagType } from 'src/types';

interface BlogTagsPropType {
  category: TagType;
  platform: TagType;
  profession: TagType;
  textClass: string;
}

const BlogTags = (props: BlogTagsPropType) => {
  const { category, platform, profession, textClass } = props;
  let tagCount = 0;

  if (category || platform || profession) {
    tagCount += 1;
  }

  return (
    <Fragment>
      {category?.slug && (
        <Tag
          tagCount={tagCount}
          endpoint="/blog/category"
          slug={category.slug}
          name={category.name}
          textClass={textClass}
        />
      )}
      {platform?.slug && (
        <Tag
          tagCount={tagCount}
          endpoint="/blog/platforms"
          slug={platform.slug}
          name={platform.name}
          textClass={textClass}
        />
      )}
      {profession?.slug && (
        <Tag
          tagCount={tagCount}
          endpoint="/blog/profession"
          slug={profession.slug}
          name={profession.name}
          textClass={textClass}
        />
      )}
    </Fragment>
  );
};

export default BlogTags;
